module.exports = __webpack_public_path__ + "img/figma.80505242.svg";